module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bk-modal-wrapper"
  }, [_c('modal', {
    staticClass: "businesskit-modal",
    attrs: {
      "title": _vm.$t('ui.segments.businesskits_modal.title'),
      "open": _vm.sendBusinessKitModalOpen,
      "saveText": _vm.$t('ui.segments.businesskits_modal.send'),
      "saveDisabled": !(_vm.selectedBusinessKitId && _vm.emailTemplatesChecked)
    },
    on: {
      "save": function($event) {
        return _vm.sendBusinessKits()
      },
      "cancel": function($event) {
        return _vm.closeSendBusinessKitModalOpen()
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "businesskit-header-modal"
        }, [_c('img', {
          attrs: {
            "src": require("../../../../assets/businesskits/businesskit-header-modal.png")
          }
        })])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('p', {
    staticClass: "title-subtext"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('ui.segments.business_kit.subtext')) + "\n    ")]), _vm._v(" "), (_vm.businessKits.length > 0) ? _c('div', [_c('field', {
    staticClass: "businesskit-select",
    attrs: {
      "model": "business_kit",
      "name": "select",
      "params": {
        no_i18n: true
      },
      "type": "select",
      "collection": _vm.businessKits,
      "value": _vm.selectedBusinessKitId,
      "autofocus": true
    },
    on: {
      "input": _vm.selectBusinessKit
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "preview-bk is-margin-top-10"
  }, [(_vm.selectedBusinessKitUrl) ? _c('a', {
    staticClass: "link",
    attrs: {
      "href": this.selectedBusinessKitUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('ui.segments.business_kit.preview')) + "\n        ")]) : _vm._e()])], 1) : _c('div', [_vm._v("\n      " + _vm._s(_vm.$t('ui.pages.lead-no-businesskit')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "segment-info"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('ui.segments.business_kit.segment_title')) + ":")]), _vm._v(" "), _c('h4', {
    staticClass: "info-text"
  }, [_vm._v("\n        " + _vm._s(this.segment && this.segment.name) + " (" + _vm._s(_vm.contactsCount) + " " + _vm._s(_vm.$t('ui.segments.business_kit.contacts')) + ")\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "email-template-info"
  }, [_c('p', {
    staticClass: "info-text"
  }, [_c('q-checkbox', {
    attrs: {
      "color": "primary",
      "label": _vm.$t('ui.segments.business_kit.email_templates_confirmation')
    },
    model: {
      value: (_vm.emailTemplatesChecked),
      callback: function($$v) {
        _vm.emailTemplatesChecked = $$v
      },
      expression: "emailTemplatesChecked"
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13247bb1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/Segments/BusinessKitModal.vue
// module id = 1820
// module chunks = 0